module.exports = __webpack_public_path__ + "static/media/img_10.7e974e1a.png";